/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 * Null when Guided Offering mode is deactivated.
 * @export
 * @interface GuiMarketSettingsGuidedOfferingSettings
 */
export interface GuiMarketSettingsGuidedOfferingSettings {
  /**
   *
   * @type {number}
   * @memberof GuiMarketSettingsGuidedOfferingSettings
   */
  etelViewIdGoStep1: number
  /**
   *
   * @type {number}
   * @memberof GuiMarketSettingsGuidedOfferingSettings
   */
  etelViewIdGoStep2: number
  /**
   *
   * @type {boolean}
   * @memberof GuiMarketSettingsGuidedOfferingSettings
   */
  extraQuestionsEnabled: boolean
  /**
   *
   * @type {string}
   * @memberof GuiMarketSettingsGuidedOfferingSettings
   */
  partPeriodGoStep1: string
  /**
   *
   * @type {string}
   * @memberof GuiMarketSettingsGuidedOfferingSettings
   */
  partPeriodGoStep2: string
}

/**
 * Check if a given object implements the GuiMarketSettingsGuidedOfferingSettings interface.
 */
export function instanceOfGuiMarketSettingsGuidedOfferingSettings(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'etelViewIdGoStep1' in value
  isInstance = isInstance && 'etelViewIdGoStep2' in value
  isInstance = isInstance && 'extraQuestionsEnabled' in value
  isInstance = isInstance && 'partPeriodGoStep1' in value
  isInstance = isInstance && 'partPeriodGoStep2' in value

  return isInstance
}

export function GuiMarketSettingsGuidedOfferingSettingsFromJSON(
  json: any,
): GuiMarketSettingsGuidedOfferingSettings {
  return GuiMarketSettingsGuidedOfferingSettingsFromJSONTyped(json, false)
}

export function GuiMarketSettingsGuidedOfferingSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GuiMarketSettingsGuidedOfferingSettings {
  if (json === undefined || json === null) {
    return json
  }
  return {
    etelViewIdGoStep1: json['etel_view_id_go_step1'],
    etelViewIdGoStep2: json['etel_view_id_go_step2'],
    extraQuestionsEnabled: json['extraQuestionsEnabled'],
    partPeriodGoStep1: json['part_period_go_step1'],
    partPeriodGoStep2: json['part_period_go_step2'],
  }
}

export function GuiMarketSettingsGuidedOfferingSettingsToJSON(
  value?: GuiMarketSettingsGuidedOfferingSettings | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    etel_view_id_go_step1: value.etelViewIdGoStep1,
    etel_view_id_go_step2: value.etelViewIdGoStep2,
    extraQuestionsEnabled: value.extraQuestionsEnabled,
    part_period_go_step1: value.partPeriodGoStep1,
    part_period_go_step2: value.partPeriodGoStep2,
  }
}
